import { render, staticRenderFns } from "./DocumentosInscricao.vue?vue&type=template&id=179766b7&scoped=true"
import script from "./DocumentosInscricao.vue?vue&type=script&lang=js"
export * from "./DocumentosInscricao.vue?vue&type=script&lang=js"
import style0 from "./DocumentosInscricao.vue?vue&type=style&index=0&id=179766b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179766b7",
  null
  
)

export default component.exports